import { APPLICATION_ROUTES } from '../constants/application-routes';
import BaseController from './BaseController';
import TASK_STATUS from '../constants/task-status';
import { FormAPI } from '@philips-internal/oswald-ui-components';
import { BrokerService } from '@philips-internal/oswald-ui-core/lib/services';
import { BS_TASK_LIST_BLOCK_PROFILE_EDITING } from '../constants/application-constants';
import TaskItem from '../interfaces/task-item';
import { isEqualShallow } from '@philips-internal/oswald-ui-utils';
import { FragmentNames } from '../codegen';
import TASK_ITEM_STATUS from '../constants/task-item-status';

enum ContextKeys {
  CURRENT_ROUTE_IS_TASKS = 'current_route_is_tasks',
  PROFILE_UPDATE_TASK = 'profileUpdateTask',
  IDENTIFIER = 'identifier',
  TASK_LIST = 'taskList',
}

abstract class ProfileBaseController extends BaseController {

  protected ContextKeys = ContextKeys;

  /**
   * Listen whether profile editing is enabled in the task module in Wizard.
   * If editing is not allowed, the form will be disabled.
   * @param formApi FormAPI
   */
  protected listenWhetherProfileEditingIsEnabled(formApi: FormAPI): void {
    const isCurrentRouteTasks = this.context.get<boolean>(ContextKeys.CURRENT_ROUTE_IS_TASKS);
    const profileUpdateTask = this.context.get<TaskItem>(ContextKeys.PROFILE_UPDATE_TASK);

    if (isCurrentRouteTasks && profileUpdateTask) {
      this.disableFormProfileByTaskStatus(isCurrentRouteTasks, profileUpdateTask, formApi);
    }

    BrokerService.subscribeToTopic(BS_TASK_LIST_BLOCK_PROFILE_EDITING, (isDisabled: boolean) => {
      this.setLockProfileForm(isDisabled, formApi);
    })
  }

  protected disableFormProfileByTaskStatus(isCurrentRouteTasks: boolean, profileUpdateTask: TaskItem, formApi: FormAPI): void {
    if (
      isCurrentRouteTasks && (profileUpdateTask?.ieStatusTarefa === TASK_STATUS.COMPLETED ||
      profileUpdateTask?.statusTaskCalculated === TASK_ITEM_STATUS.BLOCKED)
    ) {
      this.setLockProfileForm(true, formApi);
    }
  }

  private setLockProfileForm(isDisabled: boolean, formApi: FormAPI): void {
    if (isDisabled === formApi.isDisabled()) {
      return;
    }

    if (isDisabled && formApi.isEditing()) {
      formApi.cancel();
    }

    formApi.setDisabled(isDisabled);
  }

  protected setContextVariablesForTaskModule(): void {
    /**
     * This fragment will possibly be embedded in the task module.
     * When accessing the fragment by task mode, some different behaviors must be performed.
     * And for this needed this information in context.
     */
    const currentRouteIsTasksNew = this.historyService.getCurrentRoute() === APPLICATION_ROUTES.TASKS;
    const currentRouteIsTasksOld = this.context.get<boolean>(ContextKeys.CURRENT_ROUTE_IS_TASKS);
    if (currentRouteIsTasksNew !== currentRouteIsTasksOld) {
      this.context.set({ [ContextKeys.CURRENT_ROUTE_IS_TASKS]: currentRouteIsTasksNew });
    }

    const identifier = this.context.get<string>(ContextKeys.IDENTIFIER);
    const nrSequencia = identifier && identifier.split(`${FragmentNames.PROFILE_UPDATE}-`)[1];
    const taskList = this.context.get<TaskItem[]>(ContextKeys.TASK_LIST);
    const profileUpdateTaskNew = nrSequencia && taskList?.find(task => task.nrSequencia === Number(nrSequencia));
    const profileUpdateTaskOld = this.context.get<TaskItem>(ContextKeys.PROFILE_UPDATE_TASK);

    if (!isEqualShallow(profileUpdateTaskNew || {}, profileUpdateTaskOld)) {
      this.context.set({ [ContextKeys.PROFILE_UPDATE_TASK]: profileUpdateTaskNew });
    }
  }

}

export default ProfileBaseController;